import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, isSelected, onSelect }) => {
  const { id, name, description, price, duration, features, popular, image } = service;

  return (
    <div 
      className={`
        relative bg-card rounded-lg border-2 transition-all duration-300 cursor-pointer
        ${isSelected 
          ? 'border-accent shadow-lg scale-105' 
          : 'border-border hover:border-accent/50 hover:shadow-soft'
        }
      `}
      onClick={() => onSelect(service)}
    >
      {/* Popular Badge */}
      {popular && (
        <div className="absolute -top-3 left-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-body font-medium">
          Most Popular
        </div>
      )}
      {/* Service Image */}
      <div className="h-48 bg-muted rounded-t-lg overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = '/assets/images/no_image.png';
          }}
        />
      </div>
      {/* Service Content */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-xl font-heading font-semibold text-primary">
            {name}
          </h3>
          <div className="text-right">
            <div className="text-2xl font-heading font-bold text-accent">
              ₹{price}
            </div>
            <div className="text-sm text-muted-foreground">
              {duration}
            </div>
          </div>
        </div>

        <p className="text-muted-foreground font-body mb-4 line-clamp-2">
          {description}
        </p>

        {/* Features */}
        <div className="space-y-2 mb-6">
          {features?.slice(0, 3)?.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={16} color="var(--color-success)" />
              <span className="text-sm font-body text-foreground">
                {feature}
              </span>
            </div>
          ))}
          {features?.length > 3 && (
            <div className="text-sm text-muted-foreground font-body">
              +{features?.length - 3} more features
            </div>
          )}
        </div>

        {/* Select Button */}
        <Button
          variant={isSelected ? "default" : "outline"}
          fullWidth
          iconName={isSelected ? "Check" : "Plus"}
          iconPosition="left"
        >
          {isSelected ? "Selected" : "Select Service"}
        </Button>
      </div>
    </div>
  );
};

export default ServiceCard;